module.exports = __webpack_public_path__ + "img/20200116155534284.f6857d63.jpg";